// @flow
import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Toggle, {ToggleItem} from 'sail/Toggle';
import Select from 'sail/Select';
import {BodyAlt} from 'sail/Text';

import {formatLanguage} from 'docs/util/integration-builder/formatLanguage';
import {usePrefs} from 'docs/data';
import type {
  Server,
  Client,
  Platform,
  Reader,
  TerminalCountry,
  SettingValue,
} from 'docs/data/integration-builder';
import {useSettingsSelectorHandler} from '../SettingsHandler';

import './Setting.scss';

type SettingProps = {|
  label: string | React.Node,
  pref: string,
  items:
    | Array<Server>
    | Array<Client>
    | Array<Platform>
    | Array<Reader>
    | Array<TerminalCountry>,
  activeItem: SettingValue,
  getExtraPrefs?: (string) => {[string]: string},
  dropdownOnly?: boolean,
|};

export const Setting = ({
  label,
  pref,
  activeItem,
  items,
  getExtraPrefs,
  dropdownOnly = false,
}: SettingProps) => {
  const {setPrefs} = usePrefs();
  const {onSettingChange} = useSettingsSelectorHandler();
  return (
    <Box
      flex={{alignItems: 'center'}}
      className={classNames('Setting', `Setting-${pref}`)}
    >
      <BodyAlt color="dark" style={{marginRight: 12}}>
        {label}
      </BodyAlt>
      {!dropdownOnly && (
        <Box className={classNames('Setting--full')}>
          <Toggle name={pref} type="radio">
            {items.map((item) => {
              return (
                <ToggleItem
                  key={item}
                  label={formatLanguage(item)}
                  checked={item === activeItem}
                  onChange={() => {
                    let extraPrefs = {};
                    if (getExtraPrefs) {
                      extraPrefs = getExtraPrefs(item);
                    }
                    const newPrefs = {[pref]: item, ...extraPrefs};
                    setPrefs(newPrefs);
                    onSettingChange(newPrefs);
                  }}
                />
              );
            })}
          </Toggle>
        </Box>
      )}
      <Box className={classNames('Setting--small')}>
        <Select
          value={activeItem}
          options={items.map((item) => {
            return {
              label: formatLanguage(item),
              value: item,
            };
          })}
          onChange={(item) => {
            let extraPrefs = {};
            if (getExtraPrefs) {
              extraPrefs = getExtraPrefs(item);
            }
            const newPrefs = {[pref]: item, ...extraPrefs};
            setPrefs(newPrefs);
            onSettingChange(newPrefs);
          }}
        />
      </Box>
    </Box>
  );
};
